export const isUsingAdminSite = () => {
    const regex = new RegExp('\/admin($|[\/])');
    return regex.test(window.location.pathname.toLowerCase());
}
